import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { getTopCars } from '../../store/actions/car.actions';
import { Car } from '../../models/car-model';
import {
  selectTopCarResults,
  selectTopCarSearchLoading,
} from '../../store/selectors/car.selectors';
import { RealEstate } from '../../models/real-estate.model';
import { selectTopRealEstateSearchResults } from '../../store/selectors/real-estate.selectors';
import { getTopRealEstates } from '../../store/actions/real-estate.actions';
import { selectIsArabic } from '../../store/selectors/language.selectors';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnDestroy {
  cars: Car[] = [];
  properties: RealEstate[] = [];

  carResults$ = this.store.select(selectTopCarResults);
  realEstateResults$ = this.store.select(selectTopRealEstateSearchResults);
  loadingCarResult$ = this.store.select(selectTopCarSearchLoading);
  loadingPropertyResult$ = this.store.select(selectTopCarSearchLoading);

  isArabic$: Observable<boolean> = this.store.select(selectIsArabic);

  private destroy$ = new Subject<void>();

  constructor(private store: Store) {
    this.carResults$.pipe(takeUntil(this.destroy$), take(1)).subscribe(() => {
      this.store.dispatch(getTopCars());
    });

    this.realEstateResults$.pipe(takeUntil(this.destroy$), take(1)).subscribe(() => {
      this.store.dispatch(getTopRealEstates());
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
